import React from "react";

const ExportFilledIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.0112 2.25195C5.04121 2.25195 4.2123 2.88554 3.89704 3.75432H20.1428C19.8271 2.88554 18.9972 2.25195 18.0272 2.25195H6.0112ZM3.00648 5.25814C1.77101 5.25814 0.748535 6.27916 0.748535 7.51462V19.5306C0.748535 20.7661 1.77101 21.7885 3.00648 21.7885H21.0334C22.2688 21.7885 23.284 20.7661 23.284 19.5306V7.51462C23.284 6.27916 22.2688 5.25814 21.0334 5.25814H3.00648ZM12.0324 8.2526C12.2263 8.25608 12.4114 8.33441 12.5488 8.4712L15.555 11.4774C15.6336 11.5447 15.6975 11.6276 15.7426 11.7208C15.7877 11.814 15.813 11.9155 15.817 12.019C15.821 12.1225 15.8035 12.2256 15.7658 12.322C15.728 12.4184 15.6707 12.506 15.5975 12.5792C15.5243 12.6524 15.4367 12.7097 15.3403 12.7474C15.244 12.7852 15.1408 12.8026 15.0373 12.7986C14.9339 12.7947 14.8324 12.7693 14.7392 12.7242C14.646 12.6792 14.5631 12.6153 14.4957 12.5367L12.7704 10.8157V18.015C12.7784 18.4409 12.4319 18.7874 12.006 18.7794C11.591 18.7709 11.2602 18.43 11.268 18.015V10.8113L9.5441 12.5367C9.46596 12.618 9.37052 12.6806 9.26486 12.72C9.15921 12.7593 9.04605 12.7744 8.93377 12.7641C8.79126 12.7499 8.65576 12.6953 8.54325 12.6067C8.43073 12.5181 8.34589 12.3992 8.29871 12.264C8.25153 12.1288 8.24398 11.9829 8.27695 11.8435C8.30993 11.7042 8.38205 11.5771 8.48482 11.4774L11.4895 8.4712C11.5608 8.4003 11.6456 8.34442 11.7388 8.30687C11.8321 8.26932 11.9319 8.25087 12.0324 8.2526Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExportFilledIcon;
